import * as React from "react";
import { css } from "aphrodite";
import { RegionListStyle } from "main/javascripts/components/molecules/Lp/RegionList/RegionListStyle";
import { Region } from "main/javascripts/models/Region";

export interface IProps {
  regions: Region[];
  linkUrl: string;
  styles?: any;
}

export const RegionList: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  return (
    <ul className={css(RegionListStyle.block)}>
      {props.regions.map((region: Region, index: number) => {
        const region_path: number | string = region.code || region.id;
        return (
          <li key={index} className={css(RegionListStyle.list)}>
            <a
              className={css(RegionListStyle.link)}
              href={`${props.linkUrl}${region_path}`}
            >
              {region.name}
            </a>
          </li>
        );
      })}
    </ul>
  );
};
